"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const urls_1 = __importDefault(require("./urls"));
const mapProfileResponse = (data) => ({
    analyticsOnboardingEnabled: data.analytics_onboarding_enabled,
    id: data.id,
    email: data.email,
    name: data.name,
    createdAt: data.created_at,
    updatedAt: data.updated_at,
    thumbnailUrl: data.thumbnail_url,
    domainId: data.domain_id,
    customerId: data.customer_id,
    enableDeviceOfflineNotifications: data.enable_device_offline_notifications,
    enableApiV3: data.enable_api_v3,
    mfaEnabled: data.mfa_enabled,
    domainRole: data.domain_role,
    remoteAssistanceGrantLevel: data.remote_assistance_grant_level,
    remoteAssistanceExpiresAt: data.remote_assistance_expires_at,
    polyServiceLevel: data.poly_service_level,
    isMultiTimezoneEnabled: data.is_multitimezone_enabled,
    isFreetrialUser: data.is_freetrial_user,
    isLocationEnabled: data.is_location_enabled,
});
const mapOnboardingResponse = (data) => ({
    name: data.name,
    completedAt: data.completed_at,
});
class UserClient {
    masquerade(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.masquerade(),
                body: { email },
            });
            return data;
        });
    }
    remoteAssist(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.supportRemoteAssist(),
                body: { email },
            });
            return data;
        });
    }
    unsubscribe(userId, email = 'device_connectivity_notifications') {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestPublic({
                method: 'POST',
                url: `${urls_1.default.unsubscribe(userId)}?email=${email}`,
            });
        });
    }
    getProfile() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.profile(),
            });
            return mapProfileResponse(data);
        });
    }
    updateProfile(profile) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.profile(),
                body: {
                    analytics_onboarding_enabled: profile.analyticsOnboardingEnabled,
                    name: profile.name,
                    enable_device_offline_notifications: profile.enableDeviceOfflineNotifications,
                    mfa_enabled: profile.mfaEnabled,
                    remote_assistance_expires_at: profile.remoteAssistanceExpiresAt,
                    remote_assistance_grant_level: profile.remoteAssistanceGrantLevel,
                },
            });
            return mapProfileResponse(data);
        });
    }
    getUserStatus(email) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestPublic({
                method: 'GET',
                url: urls_1.default.userStatus(email),
            });
        });
    }
    setRemoteAssistance(grantLevel, expiresAt) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.setRemoteAssistance(),
                body: {
                    remote_assistance_grant_level: grantLevel,
                    remote_assistance_expires_at: expiresAt,
                },
            });
        });
    }
    changeEmail(email, password) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.changeEmail(),
                body: {
                    email,
                    password,
                },
            });
        });
    }
    getOnboardingStatus(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.onboarding(query),
            });
            return data.map(mapOnboardingResponse);
        });
    }
    updateOnboardingStatus(name) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'POST',
                url: `${urls_1.default.onboarding()}`,
                body: {
                    name,
                },
            });
        });
    }
}
exports.default = UserClient;
